var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThumbsUp = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.066 2.192a.75.75 0 0 1 .684-.442h.5A2.25 2.25 0 0 1 10.5 4v2.25h2.846a1.75 1.75 0 0 1 1.653 2.322l-1.557 4.5a1.75 1.75 0 0 1-1.654 1.178H3.25C2.56 14.25 2 13.69 2 13V8c0-.69.56-1.25 1.25-1.25h1.765l2.051-4.558ZM4.75 8.25H3.5v4.5h1.25v-4.5Zm1.5 4.5h5.538a.25.25 0 0 0 .236-.168l1.558-4.5a.25.25 0 0 0-.236-.332H9.75A.75.75 0 0 1 9 7V4a.75.75 0 0 0-.75-.75h-.015L6.25 7.661v5.089Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgThumbsUp);
export default ForwardRef;